import { envSchema, type Env } from "./env-schema";

// Should only be used once, in the entry point of the application
export function parseMetaEnv(metaEnv: ImportMetaEnv): Env {
  return envSchema.parse(metaEnv);
}
